import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

// mui imports
import { Container, Grid, useMediaQuery } from '@mui/material';

// custom components
import { SideBar } from 'components';

import HeaderComponent from 'components/Header/HeaderComponent';

const MainLayout = () => {
  const navigate = useNavigate();
  const matches = useMediaQuery('(min-width:600px)');
  useEffect(() => {
    if (sessionStorage.getItem('username') == null) {
      navigate('/login');
    }
  });
  return (
    <Container
      disableGutters={true}
      sx={{
        overflowY: 'hidden',
        p: 0,
        margin: '0',
        maxWidth: '100vw !important',
        display: 'flex !important',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
      <HeaderComponent />
      <Grid
        container
        columns={12}
        rowspacing={{ xs: 1, md: 0 }}
        columnSpacing={{ lg: 5 }}
        sx={{
          px: 2,
          py: 3,
          background: '#ffffff',
          width: '103% !important',
          marginTop: matches ? '100px !important' : '90px !important'
        }}>
        <Grid item xs={12} lg={3}>
          <SideBar />
        </Grid>

        <Grid item xs={12} lg={9}>
          <Outlet />
        </Grid>
      </Grid>
    </Container>
  );
};

export default MainLayout;
